import React, { useState } from "react";
import { connect } from "react-redux";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { Paper, TextField, Grid , Checkbox, FormControlLabel} from "@material-ui/core";
import { Button } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import { toast } from "react-toastify";
import { updateEmployee } from "@redux/actions";
import styles from "./styles";
import { getAssignedQuota } from "@utils/utils";

const LeavesQuota = (props) => {
  const { employeeData, classes, openModal , fetchEmployees} = props;
  const [additionalQuota, setAdditionalQuota] = useState(0);
  const [resetQuota, setResetQuota] = useState(false);
  let quota = 0; // Initialize quota as zero

  if (employeeData.contract_id?.contract === "Permanent") {
    const contractPayload =
      employeeData.contract_id && typeof employeeData.contract_id === "object"
        ? employeeData.contract_id
        : { updated_at: employeeData.updated_at };
    quota = getAssignedQuota(contractPayload);
  } else if (employeeData.yearly_quota !== null && employeeData.yearly_quota !== undefined) {
    quota = employeeData.yearly_quota;
  }
  const totalQuota = Number(quota) + Number(employeeData?.additional_yearly_quota);
  const handleSubmit = async (e) => {
    e.preventDefault();

    const finalData = {
      ...employeeData,
      yearly_quota: quota,
      additional_yearly_quota: resetQuota ? - Number(employeeData?.additional_yearly_quota): Number(additionalQuota)
    };

    const response = await props.updateEmployee(finalData);
    const { message, success } = response.data;
    if(success) {
      setAdditionalQuota(0);
      await fetchEmployees();
    }
    toast(message, {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "dark",
      type: success ? "success" : "error",
    });
    setTimeout(() => openModal(), 2000);
  };
  return (
    <div>
      <Modal
        open={true}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        className={classes.modalStyle}
      >
        <Fade in={true}>
          <Paper elevation={3} variant="normal" square>
            <div className={classes.modalHeader}>
              <p>Add Yearly Quota</p>
            </div>
            <div className={classes.modalBody}>
              <Paper className={classes.paper}>
                <form
                  className={classes.form}
                  autoComplete="off"
                  onSubmit={handleSubmit}
                >
                  <TextField
                    id="quota"
                    name="quota"
                    label="Yearly Quota"
                    type="number"
                    value={totalQuota}
                    fullWidth
                    required
                    InputProps={{ readOnly: true }}
                    className={classes.textField}
                    margin="normal"
                  />
                  <TextField
                    id="additionalQuota"
                    name="additionalQuota"
                    label="Additional Quota"
                    type="number"
                    value={additionalQuota}
                    onChange={(e) => setAdditionalQuota(e.target.value)}
                    fullWidth
                    required
                    className={classes.textField}
                    margin="normal"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={resetQuota}
                        onChange={()=>setResetQuota(!resetQuota)}
                        color="primary"
                        
                      />
                    }
                    label="Reset Additional Quota"
                    style={{marginTop:30}}
                  />
                  <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="flex-end"
                  >
                    <Grid item>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        className={classes.submitButton}
                        onClick={openModal}
                      >
                        Close
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.submitButton}
                      >
                        Add
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </div>
          </Paper>
        </Fade>
      </Modal>
    </div>
  );
};

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps, {
  updateEmployee,
})(withStyles(styles)(LeavesQuota));
